// src/components/BotMessage.js

import React from 'react';

function BotMessage({ message, subtitleMode }) {
  const getSubtitleText = () => {
    if (subtitleMode === 'EN') return message.english;
    if (subtitleMode === 'JP') return message.japanese;
    return ''; // Return empty for 'OFF'
  };

  const text = getSubtitleText();
  if (!text) return null; // Don't render a bubble if subtitles are off

  return (
    <div className="bot-speech">
      {/* The avatar is now in the main App layout, so it's removed from here */}
      <p className="subtitle">{text}</p>
    </div>
  );
}

export default BotMessage;